<template>
  <div class="dashboard-wrapper">
    <div v-if="!showNewVersion" class="old-version-wrapper">
      <DashboardOld />
    </div>
    <DashboardNew v-else @switchVersion="showNewVersion = false" />
  </div>
</template>

<script>
import DashboardOld from "./DashboardOld.vue";
import DashboardNew from "./DashboardNew.vue";

export default {
  name: "Dashboard",
  components: {
    DashboardOld,
    DashboardNew
  },
  data() {
    return {
      showNewVersion: true
    };
  }
};
</script>

<style scoped>
.dashboard-wrapper {
  width: 100%;
  height: 100%;
}
.old-version-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.switch-new-btn-container {
  position: absolute;
  top: 10px;
  right: 100px;
  z-index: 1000;
}
</style>
